import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import { scrollBarStyle, astriskStyle } from 'src/styles/CommonStyles.styled';
import { CURSOR, NONE, FONT_FAMILY_DEMI, FONT_FAMILY_REGULAR, SEMANTIC_TEXT_PX, X_SMALL_TEXT_PX, SMALL_TEXT_PX, BASE_TEXT_PX, X_LARGE_TEXT_PX, LARGE_TEXT_PX, DARK_NAVY_FONT_COLOR, BLACK_FONT_COLOR, DARK_GRAY_FONT_COLOR, GRAY_FONT_COLOR, TITLE_FONT_COLOR, UNSET, DISPLAY, FONT_FAMILY_ITALIC } from '../../../styles/fonts/MCFontConstants';
export const TemplateContainer = styled.div`
    ${scrollBarStyle}
    padding-right: 8px;
    display: flex;
    flex-direction: column;
    height: ${({ height }) => (height ? height : '83%')};
    overflow-y: scroll;
    overflow-x: hidden;
    padding-bottom: ${({ paddingBottom }) =>
        paddingBottom ? paddingBottom : '0px'};
    ${media.mobileDevice`
    height: 100%;
    overflow-y: ${UNSET};
    margin: 4px;
    padding-right: 0px;
    &::-webkit-scrollbar {
        display: ${NONE};
    }
    `}
`;

export const FooterContainer = styled.div`
    position: absolute;
    bottom: 0;
    right: -16px;
    left: -16px;
    ${media.mediumDevice`
       margin-top: 17px;
    `};
`;
export const TemplateTitleContainer = styled.div`
    display: flex;
    flex-direction: row;
    margin: 4px 16px 0px 4px;
    justify-content: space-between;
    align-items: center;
    ${media.mobileDevice`
        margin: 21px 20px 0px 21px;
    `}
`;

export const TemplateTitle = styled.div`
    letter-spacing: 0px;
    color: #130e4a;
    opacity: 1;
    text-align: left;
    font-family: ${FONT_FAMILY_DEMI};
    font-size: ${BASE_TEXT_PX}
`;

export const Icon = styled.img.attrs((props) => ({
    src: props.mobilePath,
}))`
    width: 21px;
    height: 20px;
    cursor: ${CURSOR};
    ${media.mobileDevice`
    display: ${(props) => (props.display ? props.display : DISPLAY)};
    `}
`;
export const Title = styled.div`
    letter-spacing: 0px;
    color: ${DARK_NAVY_FONT_COLOR};
    text-transform: uppercase;
    opacity: 1;
    font-size: ${X_LARGE_TEXT_PX};
    text-align: left;
    line-height: 1.6;
    margin: 12px 24px 13px 24px;
    font-family: ${FONT_FAMILY_DEMI};
    order: 1;
    ${media.mobileDevice`
        order: 1;
        margin-right: 45px;
    `}
`;
export const SubContainerRows = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    ${media.smalDevice`
        flex-direction: column;
    `}
`;
export const LabelsContainer = styled.div`
    display: flex;
    flex-direction: row;
    margin: 4px 24px 21px 24px;
    align-items: center;
    justify-content: flex-start;
    order: 3;
    ${media.mobileDevice`
        order: 2;
    `}
`;
export const LabelItem = styled.div`
    background: #e8e8e8 0% 0% no-repeat padding-box;
    border-radius: 17px;
    opacity: 1;
    letter-spacing: -0.1px;
    color: #313131;
    opacity: 1;
    font-family: ${FONT_FAMILY_REGULAR};
    margin-right: 16px;
    padding: 1px 6px;
    font-size: ${SMALL_TEXT_PX};
`;

export const UserAndFavoritesContainer = styled.div`
    display: flex;
    flex-direction: row;
    margin: 4px 20px 21px 24px;
    align-items: center;
    justify-content: space-between;
    order: 2;
    ${media.mobileDevice`
        order: 3;
        margin: 4px 20px 8px 24px;
    `};
`;

export const UserNameAndDateContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin-right: 26px;
    margin-left: 27px;
    ${media.mobileDevice`
       margin-right: auto;
    `};
    & .userName {
        letter-spacing: 0;
        text-align: left;
        font-family: ${FONT_FAMILY_DEMI};
        letter-spacing: 0px;
        color: ${DARK_NAVY_FONT_COLOR};
        opacity: 1;
        font-size: ${SMALL_TEXT_PX};
    }

    & .dateStamp {
        text-align: left;
        font-family:  ${FONT_FAMILY_REGULAR};
        letter-spacing: -0.1px;
        color: ${BLACK_FONT_COLOR};
        opacity: 0.6;
        font-size: ${SMALL_TEXT_PX};
        margin-top: -5px;
    }
`;
export const FavoriteIconContainer = styled.div`
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 2px #00000029;
    border: 1px solid #ebebeb;
    border-radius: 6px;
    opacity: 1;
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: ${({ marginRight }) => marginRight};
`;

export const MoreInfoContainer = styled.div`
    background: #ffffff 0% 0% no-repeat padding-box;
    border-radius: 6px;
    opacity: 1;
    display: flex;
    flex-direction: column;
    margin: 0;
    /* ${media.mobileDevice`
       flex-direction: row;
       flex-wrap: wrap;
    `}; */
`;
export const CommonItemsMainContainer = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    ${media.mobileDevice`
       flex-direction: column;
       width: 100%;
    `};
`;
export const CommonItemsContainer = styled.div`
    margin-top: ${({ hideMargin }) => (hideMargin ? '0px' : '20px')};
    margin-bottom: ${({ marginBottom }) =>
        marginBottom ? marginBottom : '0px'};
    display: flex;
    flex-direction: column;
    flex-basis: ${({ flexbasis }) => (flexbasis ? flexbasis : '50%')};
    margin-left: ${({ marginLeft }) => (marginLeft ? marginLeft : '19px')};
    margin-right: ${({ marginRight }) => (marginRight ? marginRight : '28px')};
    align-items: ${({ alignItemsCenter }) =>
        alignItemsCenter ? 'center' : ''};

    ${media.mobileDevice`
        flex-basis: 100%;
    `};
`;

export const AccountPhysicianProceduContainer = styled(MoreInfoContainer)`
    //margin: 2px;
    margin-top: 32px;
    flex-wrap: wrap;
    display: ${DISPLAY};
    margin-bottom: ${({ marginbottom }) =>
        marginbottom ? marginbottom : '0px'};
    margin-left: -25px;
    ${media.mobileDevice`
        margin-left: 16px;
        margin-right:16px;
        padding-top:16px;
        box-shadow: 0px 0px 6px #00000029;
    `};
`;

export const SetsAndItemsContainer = styled(MoreInfoContainer)`
    margin-top: 2px;
    margin-bottom: 8px;
`;

export const MoreInfoItemTitle = styled.div`
    letter-spacing: 0px;
    text-align: left;
    color: ${DARK_GRAY_FONT_COLOR};
    opacity: 1;
    font-family: ${FONT_FAMILY_DEMI};
    font-size: ${LARGE_TEXT_PX};
    //margin: 0px 0px 0px 20px;
`;

export const MoreInfoItemValue = styled(MoreInfoItemTitle)`
    font-family: ${FONT_FAMILY_REGULAR};
    //margin-bottom: 18px;
`;
export const DeleteIconView = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding-right: ${({ paddingRight }) =>
        paddingRight ? paddingRight : '15px'};
`;
export const AccPhysProceTitle = styled(MoreInfoItemTitle)`
    font-family: ${FONT_FAMILY_DEMI};
    margin-top: ${({ marginTop }) => (marginTop ? marginTop : '0px')};
    margin-right: ${({ marginRight }) => (marginRight ? marginRight : '0px')};
    margin-bottom: ${({ marginBottom }) =>
        marginBottom ? marginBottom : '6px'};
    margin-left: ${({ marginLeft }) => (marginLeft ? marginLeft : '20px')};
    font-size: ${SMALL_TEXT_PX};
    ${astriskStyle};
`;
export const AccPhysProceValue = styled(MoreInfoItemTitle)`
    font-family: ${FONT_FAMILY_REGULAR};
    padding-bottom: ${({ addExtraPadding }) =>
        addExtraPadding ? '21px' : '3px'};
    font-size: ${BASE_TEXT_PX};
`;
export const NoOptionalContainer = styled.div`
    padding-left: 15px;
`;

export const ChipContainer = styled.div`
    display: flex;
    flex-direction: row;
    margin: 0px 10px 0px 0px;
    align-items: center;
    justify-content: flex-start;
    & .chipName {
        font-size: ${X_SMALL_TEXT_PX};
        font-family: ${FONT_FAMILY_REGULAR};
        padding: 0px !important;
    }
    .MuiChip-label {
        font-size: ${X_SMALL_TEXT_PX};
        font-family: ${FONT_FAMILY_REGULAR};
    }
    .MuiChip-root {
        padding: 0px !important;
    }
    ${media.mobileDevice`
    margin: -12px 0px 0px 0px;
`}
`;

export const FavouriteIcon = styled.img.attrs((props) => ({
    src: props.mobilePath,
}))`
    width: 26px;
    height: 26px;
    display: ${DISPLAY};
    cursor: ${CURSOR};
`;

export const CustomizeRowView = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 100%;
    margin: 15px 4.5px 0px -2px;
    ${media.mobileDevice`
    margin-left: 16px;
    margin-right:7px;
    margin-bottom:0px;
    width: ${UNSET};
    flex-direction: row;
    margin: 15px 4.5px 0px 4px;
`};
`;

export const AutoCompleteDiv = styled.div`
    // width: 97%;
    // margin-left: 20px;
`;
export const AutoCompleteContainer = {
    width: '100%',
    marginTop: '10px',
};
export const RadioRowDiv = styled.span`
    display: inline-flex;
    width: ${({ width }) => (width ? width : '100%')};
    margin-bottom: ${({ marginBottom }) => marginBottom};
`;
export const RowContainer = styled.div`
    display: flex;
    flex-direction: row;
    flex-basis: 100%;
    ${media.mobileDevice`
    flex-direction:column;
    flex-basis: ${UNSET};
    `};
`;

export const AccountGroup = styled.div`
    flex-basis: 48%;
    ${media.mobileDevice`
    flex-basis: ${UNSET};
`};
`;

export const PhysicianGroup = styled.div`
    flex-basis: 48%;
    margin-left: 52px;
    ${media.mobileDevice`
        flex-basis: ${UNSET};
        margin-left: ${UNSET};
`};
`;

export const OptionalLoadMoreView = styled.div`
    background-color: #f5f5f5;
    height: ${({ height }) => (height ? height : '200px')};
    max-height: ${({ maxHeight }) => (maxHeight ? maxHeight : UNSET)};
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: scroll;
    margin: ${({ margin }) => (margin ? margin : '0px 0 0 0')};
    flex-direction: column;
    width: 100%;
    & p {
        color: ${GRAY_FONT_COLOR};
        font-size: ${LARGE_TEXT_PX};
        /* width: 11em; */
        font-family: ${FONT_FAMILY_REGULAR};
        word-break: break-word !important;
        text-align: center;
        margin-bottom: 20px;
    }
    & button {
        padding: 10px;
        color: ${TITLE_FONT_COLOR};
        border: 1px solid #1010eb;
        border-radius: 20px;
        text-align: center;
        padding: 5px 13px;
        font-family: ${FONT_FAMILY_DEMI};
        font-size: ${SEMANTIC_TEXT_PX};
        background: #f5f5f5;
    }
`;
export const MainContainerItems = styled.div`
    width: ${({ width }) => (width ? width : '47%')};
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    margin-top: ${({ marginTop }) => (marginTop ? marginTop : '')};
    margin-bottom: ${({ setMarginBottom }) =>
        setMarginBottom ? '16px' : '0px'};
    padding: ${({ padding }) => (padding ? padding : '15px 24px 0px 29px')};
    ${media.mobileDevice`
        width: 100%;
        padding: ${({ padding }) => (padding ? padding : '10px 24px 0px 32px')};
    `};
`;

export const ExpirationTitle = styled.div`
    font-family: ${FONT_FAMILY_DEMI};
    color: ${DARK_GRAY_FONT_COLOR};
    font-size: ${SMALL_TEXT_PX};
    margin-bottom: 8px;

    &:after {
        content: '${(props) => (props.showAstrisk ? '*' : '')}';
        color: red;
        padding-left: 3px;
    }
`;

export const StyledNoOptionMsg = styled.p`
  font-size: ${X_SMALL_TEXT_PX};
  margin-bottom: 5px;
`;

export const StyledNoFavoriteMsg = styled.p`
  margin-bottom: 7px;
`;

export const StyledSwitchButton = styled.button`
  width: 236px;
  font-size: ${SEMANTIC_TEXT_PX};
`;

export const FlexDisplay = styled.div`
  display: flex;
`;

export const FullWidthDiv = styled.div`
  width: 100%;
`;

export const StyledAutoCompleteInput = {
  height: '40px',
  width: '100%',
  border: '1px solid #cccccc',
  borderRadius: '4px',
};

export const ItalicAccountId = styled.div`
  font-family: ${FONT_FAMILY_ITALIC};
  font-size: 15px;
  display: flex;
  align-items: center;
`;

export const FlexRowSpaceBetween = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`;
